import { adminUsersByIdLinksInvitationGetSlice } from './get';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { adminUsersByIdLinksInvitationSendReducers, adminUsersByIdLinksInvitationSendWatchers } from './send';

export const adminUsersByIdLinksInvitationReducers = combineReducers({
	get: adminUsersByIdLinksInvitationGetSlice.asyncReducers,
	send: adminUsersByIdLinksInvitationSendReducers
});

export const adminUsersByIdLinksInvitationWatchers = combineAllWatchers([
	adminUsersByIdLinksInvitationGetSlice.asyncWatchers,
	adminUsersByIdLinksInvitationSendWatchers
]);
